import { render, staticRenderFns } from "./1.vue?vue&type=template&id=f5b4e772&scoped=true"
import script from "./1.vue?vue&type=script&lang=js"
export * from "./1.vue?vue&type=script&lang=js"
import style0 from "./1.vue?vue&type=style&index=0&id=f5b4e772&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b4e772",
  null
  
)

export default component.exports